var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "modal fade",
      attrs: { id: "confirmPopup", role: "dialog" },
    },
    [
      _c("div", { staticClass: "modal-dialog profile-confirm-poup" }, [
        _c("div", { staticClass: "modal-content" }, [
          _vm._m(0),
          _c("div", { staticClass: "modal-body confirm-body col-xs-12 pt-0" }, [
            _c(
              "div",
              {
                staticClass: "col-xs-12 mb-12",
                class: { documentConfirmation: _vm.documentDetails },
              },
              [_vm._v(" " + _vm._s(_vm.confirmationMessage) + " ")]
            ),
            _vm.documentDetails
              ? _c("div", { staticClass: "col-xs-12" }, [
                  _c("div", { staticClass: "col-xs-12 documentName mb-15" }, [
                    _vm._v(
                      " " + _vm._s(_vm.documentDetails.document_name) + " "
                    ),
                  ]),
                  _c("div", { staticClass: "col-xs-12 doc-warning" }, [
                    _vm._v(
                      " By uploading a new version of this document, the original document will be replaced. This action cannot be undone. "
                    ),
                  ]),
                ])
              : _vm._e(),
          ]),
          _c("div", { staticClass: "modal-footer confirmpopup-bgcolor" }, [
            !_vm.documentDetails
              ? _c("div", { staticClass: "col-xs-12" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-md-6 col-sm-6 col-xs-12 profile-footer-save",
                    },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-block emergo-green-button",
                          attrs: { type: "button" },
                          on: { click: _vm.closeDialog },
                        },
                        [_vm._v("Continue")]
                      ),
                    ]
                  ),
                  _c(
                    "div",
                    { staticClass: "col-md-6 col-sm-6 col-xs-12 p-0" },
                    [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-block emergo-white-button",
                          attrs: { type: "button" },
                          on: { click: _vm.discardChanges },
                        },
                        [_vm._v("Discard Changes")]
                      ),
                    ]
                  ),
                ])
              : _c("div", { staticClass: "col-xs-12" }, [
                  _c("div", { staticClass: "col-md-6 col-sm-6 col-xs-12" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-block emergo-white-button",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.uploadNewVersion(false)
                          },
                        },
                      },
                      [_vm._v("Cancel")]
                    ),
                  ]),
                  _c("div", { staticClass: "col-md-6 col-sm-6 col-xs-12" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-block emergo-blue-button",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.uploadNewVersion(true)
                          },
                        },
                      },
                      [_vm._v("Yes upload new version")]
                    ),
                  ]),
                ]),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "div",
      { staticClass: "modal-header confirmpopup-bgcolor pb-0" },
      [
        _c(
          "button",
          {
            staticClass: "close",
            attrs: {
              type: "button",
              "data-toggle": "modal",
              "data-target": "#confirmPopup",
            },
          },
          [_vm._v("×")]
        ),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }